<template>
    <div>
      <Header></Header>
      <div class="box">
        <div class="content">
        <div style="text-align:center;">
          <h1>个人中心</h1>
          <div style="font-size:18px;margin: 20px 0;">
            帐号：{{email}}
          </div>
        </div>
        <div>
          <h1>
          已购内容
          </h1>
          <List border>
            <ListItem v-for="(item, key) in tools"  :key="key">{{ item.t_type }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.end_at}}
            </ListItem>
            <ListItem >Chrome扩展版本:{{kzversion}}<span v-if="kzversion != lastversion">&nbsp;&nbsp;最新版本为{{lastversion}}，请及时更新&nbsp;&nbsp;</span>
            <a v-if="kzversion != lastversion" class="sec" href="https://cmshj.oss-cn-beijing.aliyuncs.com/data/dtool.zip?v=2">点击这里下载新版Chrome扩展插件</a>
            </ListItem>
          </List>
          <p>采集次数 = 词数 * 年数 * 地区数 （说明：全国总数按一个地区算，不足年的按1年算）</p>
          <div style="margin: 20px 0;font-size: 16px;">
            <h2>百度指数采集工具价格</h2>
            <p style="text-align:left;color:red; font-size:20px">采集次数促销活动价格</p>
            <p> 5元150个请求次数，6.6折 &nbsp;&nbsp;<span class="hx">（原价100个请求次数）</span></p>
              <p> 50元2100个请求次数，4.7折 &nbsp;&nbsp;<span class="hx">（原价1100个请求次数，9折）</span></p>
              <p> 100元5500个请求次数，3.6折 &nbsp;&nbsp;<span class="hx">（原价2400个请求次数，8.3折）</span></p>
            <br>
            <p><span style="color:red">微信直接充值，</span>客服微信：<span style="color:red">uunn688688</span>，直接微信转账给客服，并把你在本站的<span style="color:red">账号发给客服</span>，用于充值。</p>
            <br>
            <h4>按时长租用价格</h4>
            <Table border :row-class-name="rowClassName" :columns="columns" :data="data"></Table>
            <br>
            <h4>服务购买方式</h4>
              <p>1.微信直接充值</p>
              <p>方法：扫码加客服，直接微信转账给客服，并把你在本站的<span style="color:red">账号发给客服</span>（注册用的那个邮箱），用于充值。</p>
              <br>
              <div style="text-align:center;">
                <img style="width:300px;height:300px;" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/qrcode.png" alt="">
              </div>
              <p>2.淘宝购买
                  <a href="https://item.taobao.com/item.htm?spm=a21dvs.23580594.0.0.621e3d0dLDaHho&ft=t&id=660750528609" target="_blank" class="tao">点击这里进入</a>
                </p>
                <br>
                <p>支付完成后，通过淘宝旺旺将你在本站注册的<span style="color:red">账号发给客服</span>，用于充值。</p>
                <br>
          </div>
          <div style="margin: 20px 0;font-size: 16px;">
            <h2>抖音指数采集工具价格</h2>
            <p style="text-align:left;color:red; font-size:20px">采集次数促销活动价格</p>
              <p> 5元35个请求次数，7.1折 &nbsp;&nbsp;<span class="hx">（原价25个请求次数）</span></p>
              <p> 50元380个请求次数，6.5折 &nbsp;&nbsp;<span class="hx">（原价250个请求次数）</span></p>
              <p> 100元880个请求次数，5.6折 &nbsp;&nbsp;<span class="hx">（原价500个请求次数）</span></p>
            <br>
            <p><span style="color:red">微信直接充值，</span>客服微信：<span style="color:red">uunn688688</span>，直接微信转账给客服，并把你在本站的<span style="color:red">账号发给客服</span>，用于充值。</p>
            <br>
            <h4>按时长租用,不限制次数价格</h4>
            <Table border :row-class-name="rowClassName" :columns="columnsjl" :data="datajl"></Table>
            <br>
            <h4>服务购买方式</h4>
              <p>1.微信直接充值</p>
              <p>方法：扫码加客服，直接微信转账给客服，并把你在本站的<span style="color:red">账号发给客服</span>（注册用的那个邮箱），用于充值。</p>
              <br>
              <div style="text-align:center;">
                <img style="width:300px;height:300px;" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/qrcode.png" alt="">
              </div>
              <p>2.淘宝购买
                  <a href="https://item.taobao.com/item.htm?spm=a21dvs.23580594.0.0.621e3d0dLDaHho&ft=t&id=660750528609" target="_blank" class="tao">点击这里进入</a>
                </p>
                <br>
                <p>支付完成后，通过淘宝旺旺将你在本站注册的<span style="color:red">账号发给客服</span>，用于充值。</p>
                <br>
          </div>
        </div>
          <br>
          <br>
          <hr>
          <br>
          <h2>版本更新说明</h2>
          <h3>1.96版本 &nbsp;&nbsp; 2024-12-29</h3>
          <p>品牌指数增加对地级市支持。</p>
          <p>修复巨量算数关键指数部分词采集不到的问题。</p>
          <br>
          <h3>1.95版本 &nbsp;&nbsp; 2024-5-08</h3>
          <p>增加巨量算数关键指数下载功能。</p>
          <br>
          <h3>1.93版本 &nbsp;&nbsp; 2024-3-10</h3>
          <p>优化数据采集过程，提升反反爬能力。这样用户的一个指数账号就可以使用更长的时间了。</p>
          <br>
          <h3>1.92版本 &nbsp;&nbsp; 2023-09-01</h3>
          <p>支持品牌指数下载</p>
          <br>
          <h3>1.91版本 &nbsp;&nbsp; 2023-05-28</h3>
          <p>搜索指数支持从2006年开始的数据采集</p>
          <br>
          <h3>1.9版本 &nbsp;&nbsp; 2022-11-19</h3>
          <p>升级扩展版本，扩展安装后不再提示错误</p>
          <br>
          <h3>1.8版本 &nbsp;&nbsp; 2022-10-22</h3>
          <p>优化采集过程，保证采集开始后可以一直工作到结束。在这里特别感谢至尊VIP用户Ysu-Tyb，感谢她对本次优化的大力支持！</p>
          <br>
          <h3>1.7版本 &nbsp;&nbsp; 2022-09-04</h3>
          <p>增加<span style="color:red">VIP包月功能</span>支持，包月后不限制采集次数</p>
          <br>
          <h3>1.6版本 &nbsp;&nbsp; 2022-08-19</h3>
          <p>增加<span style="color:red">继续采集</span>按钮，采集因为某种原因中断，问题处理后，可以点击继续采集按钮继续，不用再重新开始了</p>
          <p>出现未收录的词都可以自动跳过，不会中断采集了</p>
          <p>优化错误提示</p>
          <br>
          <h3>1.5版本 &nbsp;&nbsp; 2022-08-03</h3>
          <p>增加自动保存文件到本地功能。采集完的数据会自动保存到本地，不用在手工点击保存按钮</p>
          <p style="color:#ff461f;">提示：新用户在自动下载的时候，需要允许下载多个文件，浏览器会提示是否允许，点一下允许就行了，否则下载一个文件之后，其余的会被限制下载</p>
          <input type="hidden" id="kzversionid" name="" v-model="kzversion">
        </div>
      </div>
    </div>
</template>
<script>
import Header from './header'
import helper from '../lib/helper'

export default {
  components: {
    Header
  },
  data () {
    return {
      email: '',
      kzversion: '',
      lastversion: '1.96',
      columns: [
        {
          title: '功能对比',
          key: 'name'
        },
        {
          title: '黄金VIP',
          key: 'vip1'
        },
        {
          title: '铂金VIP',
          key: 'vip2'
        },
        {
          title: '至尊VIP',
          key: 'vip3'
        }
      ],
      data: [
        {
          name: '同时输入关键字数',
          vip1: '最多5个词',
          vip2: '最多10个词',
          vip3: '最多500个词'
        },
        {
          name: '同时选择地区数',
          vip1: '1个',
          vip2: '5个',
          vip3: '不限制'
        },
        {
          name: '时间选择',
          vip1: '2011年后任意时段',
          vip2: '2011年后任意时段',
          vip3: '2011年后任意时段'
        },
        {
          name: '采集次数',
          vip1: '不限制次数',
          vip2: '不限制次数',
          vip3: '不限制次数'
        },
        {
          name: '自动保存本地',
          vip1: '支持',
          vip2: '支持',
          vip3: '支持'
        },
        {
          name: '原价',
          vip1: '39元/月，119元/年',
          vip2: '60元/天，150元/周，300元/月，1200元/年',
          vip3: '200元/天，500元/周，1200元/月，3000元/年'
        },
        {
          name: '活动价格',
          vip1: '37元/月，89元/年',
          vip2: '49元/天，119元/周，279元/月，979元/年',
          vip3: '149元/天，449元/周，979元/月，2799元/年'
        }
      ],
      columnsjl: [
        {
          title: '功能对比',
          key: 'name'
        },
        {
          title: '黄金VIP',
          key: 'vip1'
        },
        {
          title: '至尊VIP',
          key: 'vip3'
        }
      ],
      datajl: [
        {
          name: '同时输入关键字数',
          vip1: '最多5个词',
          vip3: '最多500个词'
        },
        {
          name: '同时选择地区数',
          vip1: '1个',
          vip3: '不限制'
        },
        {
          name: '时间选择',
          vip1: '2019年后任意时段',
          vip3: '2019年后任意时段'
        },
        {
          name: '采集次数',
          vip1: '不限制次数',
          vip3: '不限制次数'
        },
        {
          name: '自动保存本地',
          vip1: '支持',
          vip3: '支持'
        },
        {
          name: '原价格',
          vip1: '50元/周，120元/月，840元/年',
          vip3: '300元/天，900元/周，1800元/月，5400元/年'
        },
        {
          name: '活动价格',
          vip1: '30元/周，80元/月，560元/年',
          vip3: '210元/天，630元/周，1200元/月，3600元/年'
        }
      ],
      tools: []
    }
  },
  mounted () {
    this.getUserInfo()
    this.getVipInfo()
  },
  methods: {
    rowClassName (row, index) {
      if (index === 5) {
        return 'old-price'
      } else if (index === 6) {
        return 'act-price'
      }
      return ''
    },
    getVipInfo () {
      // 获取用户信息
      var that = this
      var url = this.$store.state.baseurl + '/mapi/user/getvip'
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          // console.log('登录成功', res.data)
          var vinfo = res.data.data
          // console.log('vinfo', vinfo)
          that.$store.commit('SETVIP', vinfo)
        } else {
          console.log('getvip error', res)
        }
      }).catch((e) => {
        console.log('获取数据失败', e)
      })
    },
    getUserInfo () {
      var uinfo = helper.getUser()
      // console.log('mine user info', uinfo)
      if (uinfo) {
        this.email = uinfo.email
      }
      var url = this.$store.state.baseurl + '/mapi/user/userorder'
      // console.log('url', url)
      var that = this
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          that.tools = res.data.data
          // console.log('获取用户信息', res.data)
        } else if (res.data.code === 401) {
          window.location.href = '/login'
        } else {
          that.$Message.info(res.data.msg)
          window.location.href = '/login'
        }
      }).catch((e) => {
        console.log('获取购买信息失败', e)
        that.$Message.info('获取购买信息失败')
      })
    }
  }
}
</script>
<style lang="less">
@media (max-width: 768px){
  .box {
    width: 90vw !important;
  }
  .tx-box {
    margin: 0 !important;
  }
  .tb-box {
    margin: 40px 0 !important;
  }

}
.ivu-table .act-price td{
  // background-color: #2db7f5;
  color: red;
}
.ivu-table .old-price td{
  // color: red;
  text-decoration: line-through;
}

.tao {
  color: #fff;
  background-color: #ec971f;
  border-color: #d58512;
  padding: 4px 8px;
  border-radius: 5px;
}

.box {
  margin: 60px auto;
  width: 60vw;
}
.head-a {
  background: #398dee;
  border-radius: 7px;
  padding: 20px;
}
.content {
  text-align: left;
  margin: 20px 0;
}
.info {
  font-size: 18px;
  line-height: 34px;
  margin: 20px 0;
}
.sec {
  font-size: 16px;
  font-weight: 400;
  color: cornflowerblue;
}

</style>



// WEBPACK FOOTER //
// src/components/mine.vue